module.exports = __webpack_public_path__ + "img/logo-b.b73d4aff.svg";